import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { UserService } from '../user/user.service';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  private globalPracticeId: number;
  private userId: number;

  constructor(userService: UserService, authService: AuthService) {
    userService.user$.subscribe((user) => {
      this.globalPracticeId = authService.getPracticeId();
      this.userId = authService.getPracticeUserId();
    });
  }

  get length(): number {
    return localStorage.length;
  }

  getItem(key: string): string {
    let item = localStorage.getItem(this.getPracticeKey(key));
    if (!item) {
      item = localStorage.getItem(this.getPracticeKeyOld(key));
    }
    return item;
  }

  getObject<T extends object>(key: string): T {
    const s = this.getItem(key);
    return s ? (JSON.parse(s) as T) : null;
  }

  setItem(key: string, value: string): void {
    localStorage.setItem(this.getPracticeKey(key), value);
  }

  setObject<T extends object>(key: string, value: T): void {
    const s = JSON.stringify(value);
    this.setItem(key, s);
  }

  removeItem(key: string): void {
    localStorage.removeItem(this.getPracticeKey(key));
  }

  key(index: number): string {
    const key = localStorage.key(index);
    return key.slice(key.indexOf('!!') + 2);
  }

  private getPracticeKey(key: string): string {
    return `${this.globalPracticeId}!${this.userId}!${key}`;
  }
  /** Key without userId, for backward compatibility */
  private getPracticeKeyOld(key: string): string {
    return `${this.globalPracticeId}!!${key}`;
  }
}
